import React, { useState } from "react"
import "./DocumentRMO.scss"
import Modal from "react-bootstrap/Modal"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import DetailedDocument from "./DetailedDocument"
import PermissionUtils from "../../../../core/store/utils/PermissionUtils"
import { useSelector } from "react-redux"
import { calculateAge } from "core/utils/date"

function DocumentsRMO({ closePrintModal, patientMOC }: any) {
  const userRole = useSelector((state: any) => state?.user?.role)

  const [show, setShow] = useState(true)
  const handleClose = () => {
    setShow(false)
    closePrintModal(false)
  }

  return (
    <div className="document-rmo-wrapper">
      <Modal size="xl" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Row>
              <Col className="basic-patient-details">
                {PermissionUtils.displayPatientName(
                  userRole,
                  patientMOC,
                  false,
                  null,
                  "-"
                )}
                {patientMOC?.mocId}-{patientMOC?.gender}-{calculateAge(patientMOC?.dob)}
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="Document-Heading">Documents</Row>
          <DetailedDocument patientDetail={patientMOC} />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </div>
  )
}

export default DocumentsRMO
function handlePrint(arg0: boolean) {
  throw new Error("Function not implemented.")
}
